import type { DirectiveBinding } from 'vue'
import { h, render } from 'vue'
import DOMPurify from 'dompurify'
import EffortLink from '@/elements/EffortLink.vue'
import { appContext } from '@/main.ts'

function applyTransformedHtml(el: HTMLElement, rawHtml: string) {
  if (!rawHtml) {
    el.innerHTML = ''
    return
  }

  // 1. Ersetze TITROP#<ID> durch Platzhalter
  const replaced = rawHtml.replace(/TITROP#(\d+)/g, (_, id) => {
    return `<effort-link-placeholder data-id="${id}"></effort-link-placeholder>`
  })

  // 2. Purify den HTML-Inhalt (mit erlaubtem Custom-Tag)
  const safeHtml = DOMPurify.sanitize(replaced, {
    ADD_TAGS: ['effort-link-placeholder'],
    ADD_ATTR: ['data-id']
  })

  // 3. Setze bereinigtes HTML in das Element
  el.innerHTML = safeHtml

  // 4. Suche Platzhalter und ersetze sie durch Vue-Komponenten
  const placeholders = el.querySelectorAll('effort-link-placeholder')
  placeholders.forEach((node) => {
    const id = node.getAttribute('data-id')
    if (!id) return

    const mountEl = document.createElement('span')
    node.replaceWith(mountEl)

    const component = h(
      EffortLink,
      {
        id: Number(id),
        fetchTitle: false,
        noIcon: true,
        inline: true,
        bordered: true
      },
      () => `TITROP#${id}`
    )

    component.appContext = appContext
    render(component, mountEl)
  })
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    applyTransformedHtml(el, binding.value)
  },
  updated(el: HTMLElement, binding: DirectiveBinding<string>) {
    if (binding.value !== binding.oldValue) {
      applyTransformedHtml(el, binding.value)
    }
  }
}
